



































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {uuid} from 'vue-uuid'
import {Question} from '@/store/modules/lib'

import LfsSelectBox from './LfsSelectBox.vue'
import LfsCheckBox from './LfsCheckBox.vue'
import LfsCheckBoxFree from './LfsCheckBoxFree.vue'
import LfsRadioBox from './LfsRadioBox.vue'
import LfsRadioBoxFree from './LfsRadioBoxFree.vue'
import LfsRadioBoxType from './LfsRadioBoxType.vue'
import LfsTextBox from './LfsTextBox.vue'
import Chip from '@/components/UI/Chip.vue'
import IQuestion from '@/models/IQuestion'

@Component({
  name: 'DetailSideBar',

  components: {
    LfsRadioBoxFree,
    LfsCheckBoxFree,
    LfsRadioBoxType,
    LfsSelectBox,
    LfsCheckBox,
    LfsRadioBox,
    LfsTextBox,
    'c-chip': Chip
  }
})
export default class DetailSideBar extends Vue {

  @Prop(Object) value!: Question

  checkFree: Boolean = false
  checkFreeType: string | undefined = 'free_text_input'

  changedTypeFree(val: string) {
    this.checkFreeType = val
    const freeAnswers = this.findFreeAnswers()
    freeAnswers[0].type = val
    this.$emit('changedQuestion')
  }

  checkFreeChange(val: Boolean): void {
    this.clearFreeAnswers()
    if (val) {
      this.value.answers.push({
        id: uuid.v1(),
        sense: (this.$moment().format('X') as string),
        order: this.value.answers.length + 1,
        value: '',
        type: this.checkFreeType
      })

      let free = this.value.answers.filter((el: any) => {
        return el.type === 'free_text_input' || el.type === 'free_number_input'
      })

      if (free.length > 0) {
        this.value.answers.splice(this.value.answers.indexOf(free[0]), 1)
        free[0].order = 200
        this.value.answers.push(free[0])
        console.log(this.value.answers)
      }
    }
    this.checkFree = val
    this.$emit('changedQuestion')
  }

  findFreeAnswers() {
    if(this.value.answers){
      return this.value.answers.filter((el: any) => {
        return el.type === 'free_text_input' || el.type === 'free_number_input'
      })
    }
    return []
  }

  clearFreeAnswers() {
    const element = this.findFreeAnswers()
    if (element.length > 0) {
      this.value.answers.splice(this.value.answers.indexOf(element[0]), 1)
    }
  }

  anotherQuestion: Boolean = false
  anotherQuestionId: String | null = null


  defaultQuestion: Question | {} = {}
  questionTitle: string = ''

  get item() {
    return this.value
  }

  set item(newItem: Question) {

    newItem.answers = newItem.type === 'text'
      ? [
        {
          id: uuid.v1(),
          sense: this.$moment().format('X'),
          order: this.value.answers.length + 1,
          value: ''
        }
      ]
      : []
    this.value = newItem
    this.changedQuestion()
  }

  @Watch('questionTitle')
  isQuestionTitleChanged(newValue: string): void {
    this.$emit('titleChanged', newValue)
  }

  @Watch('value.type')
  isNewValueChanged(newValue: IQuestion): void {
    if (this.value.type === 'select') {
      if (this.value.id === this.anotherQuestionId) {
        this.value.specify = 'single'
        this.value.answers = []
      }

    }
    if (this.value.type === 'text') {
      if (this.value.id === this.anotherQuestionId) {
        this.value.specify = 'text'
        this.value.answers = []
        this.value.answers.push({
          id: uuid.v1(),
          sense: (this.$moment().format('X') as string),
          order: this.value.answers.length + 1,
          value: '',
          type: 'regular'
        })
        this.clearFreeAnswersCheck()
      }

    }
    // this.changedQuestion()
  }

  clearFreeAnswersCheck() {
    let freeAnswear = this.findFreeAnswers()
    if (freeAnswear.length > 0) {
      this.checkFreeType = freeAnswear[0].type
      this.checkFree = true
    } else {
      this.checkFree = false
      this.checkFreeType = 'free_text_input'
    }
  }

  @Watch('value')
  isValueChanged(newValue: IQuestion): void {
    this.clearFreeAnswersCheck()

    this.anotherQuestionId = newValue.id
    this.questionTitle = newValue.text
  }

  changedImportantQuestion(val: any) {
    this.value.important = val
    this.$emit('changedQuestion')
  }

  changedAnotherQuestion(val: any) {
    this.anotherQuestion = val
    if (val) {
      this.value.answers.push({
        id: uuid.v1(),
        sense: (this.$moment().format('X') as string),
        order: this.value.answers.length + 1,
        value: '',
        type: 'free_text_input'
      })
    } else {
      this.value.answers.splice(this.value.answers.indexOf(this.value.answers.filter((el) => {
        return el.type === 'free_text_input' || el.type === 'free_number_input'
      })[0]), 1)
    }
    this.changedQuestion()
  }

  changedQuestion() {
    this.$emit('changedQuestion')
  }
}
